document.addEventListener("DOMContentLoaded", function () {
  // Helper: format money using Shopify's formatter if available
  const moneyFormat =
    (window.Shopify && Shopify.money_format) || "${{amount}}";

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    // Fallback: basic formatting with $ prefix
    const value = (cents / 100).toFixed(2);
    return "$" + value;
  }

  // Get cached variant JSON for a given <product-card>
  function getVariantsData(card) {
    if (!card) return null;
    if (card._variantsData) return card._variantsData;

    const script = card.querySelector("script.product-card-variants");
    if (!script) return null;

    try {
      const data = JSON.parse(script.textContent);
      card._variantsData = data;
      return data;
    } catch (e) {
      console.warn("Error parsing product-card variant JSON", e);
      return null;
    }
  }

  function updatePriceForVariant(card, variantId) {
    const variants = getVariantsData(card);
    if (!variants) return;

    const idNum = Number(variantId);
    const variant = variants.find((v) => Number(v.id) === idNum);
    if (!variant) return;

    const info = card.querySelector(".product-card__info");
    if (!info) return;

    const priceList = info.querySelector("price-list");
    if (!priceList) return;

    const salePriceEl = priceList.querySelector("sale-price");
    const comparePriceEl = priceList.querySelector("compare-at-price");

    // Ensure we keep the original sr-only label for accessibility
    if (salePriceEl && !salePriceEl.dataset.label) {
      const sr = salePriceEl.querySelector(".sr-only");
      if (sr) {
        salePriceEl.dataset.label = sr.outerHTML;
      }
    }
    if (comparePriceEl && !comparePriceEl.dataset.label) {
      const sr = comparePriceEl.querySelector(".sr-only");
      if (sr) {
        comparePriceEl.dataset.label = sr.outerHTML;
      }
    }

    // Update sale price (the main visible price)
    if (salePriceEl) {
      const label = salePriceEl.dataset.label || "";
      salePriceEl.innerHTML = label + formatMoney(variant.price);
    }

    // Update compare-at price & show/hide it depending on discount
    if (comparePriceEl) {
      const label = comparePriceEl.dataset.label || "";
      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        comparePriceEl.innerHTML =
          label + formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = "";
      } else {
        // Keep label for screen readers, hide the visible price
        comparePriceEl.innerHTML = label;
        comparePriceEl.style.display = "none";
      }
    }

    // Optional: update any on-sale badge with per-variant % if present
    const discountBadge = card.querySelector("on-sale-badge");
    const discountLabel = card.querySelector("[data-discount-label]");
    const hasDiscount =
      variant.compare_at_price && variant.compare_at_price > variant.price;

    if (hasDiscount) {
      const percent = Math.round(
        ((variant.compare_at_price - variant.price) * 100) /
          variant.compare_at_price
      );

      if (discountBadge) {
        // Update the badge near the product image (if present)
        discountBadge.textContent = `Save ${percent}%`;
      }

      if (discountLabel) {
        // Update the text label near the price inside product-card__info
        discountLabel.textContent = `Save ${percent}%`;
        discountLabel.classList.remove("hidden");
      }
    } else {
      // No discount on this variant: hide/clear the discount label, keep badge text as-is
      if (discountLabel) {
        discountLabel.textContent = "";
        discountLabel.classList.add("hidden");
      }
    }
  }

  function updateCardLinks(card, variantId) {
    const handle = card.getAttribute("handle");
    if (!handle || !variantId) return;

    const anchors = card.querySelectorAll(
      `a[href*="/products/${handle}"]`
    );

    anchors.forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set("variant", variantId);
        link.href = url.pathname + url.search + url.hash;
      } catch (e) {
        // ignore invalid URLs
      }
    });
  }

  function handleVariantChange(event) {
    const target = event.target;
    let variantId = null;
    let card = null;

    // 1) Dropdown inside product-card__info
    if (target.matches('.variant-select[name="id"]')) {
      card = target.closest("product-card");
      variantId = target.value;
    }

    // 2) Impact's built-in swatches / variant radios on the card
    if (
      !variantId &&
      target.matches(
        ".product-card__swatch-list [type='radio'], .product-card__variant-list [type='radio']"
      )
    ) {
      card = target.closest("product-card");
      variantId = target.getAttribute("data-variant-id");
    }

    if (!card || !variantId) return;

    updatePriceForVariant(card, variantId);
    updateCardLinks(card, variantId);
  }

  // Global delegate: works for all current & future product cards
  document.addEventListener("change", handleVariantChange);
});
